import { Button, buttonClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Colors } from '../../../../../ui/layout/theme-next';

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0.5),
  padding: 0,
  transition: 'none',
  borderRadius: '100px',

  '&:hover': {
    backgroundColor: 'unset',
  },

  [`&.${buttonClasses.disabled}`]: {
    color: Colors.textDisabled,
    backgroundColor: Colors.white,
  },

  '.button-label': {
    padding: theme.spacing(1.25, 2.5),
    fontFamily: 'Sora',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '15px',
    backgroundColor: Colors.white,
    color: Colors.primary,
    borderRadius: '100px',
    minWidth: '72px',
    textAlign: 'center',
  },
}));
